import { computed, Injectable, inject } from '@angular/core';
import { ai as AiGen, challenge as ChallengeGen } from '@valvur/shared-grpc';
import { CourseSettingsData } from '../../../models';
import { CourseService } from '../../../services/course.service';
import type { CourseCreatorBridge } from './course-creator-bridge.token';

/**
 * School “My courses” host: FormData create, full publish / media mutations.
 * Admin-only paths throw if mis-wired.
 */
@Injectable()
export class SchoolCourseCreatorBridge implements CourseCreatorBridge {
  #course = inject(CourseService);

  readonly isPublishPending = computed(() =>
    this.#course.publishCourse.isPending(),
  );

  createSchoolDraft(payload: CourseSettingsData): void {
    this.#course.createCourse.mutate(payload);
  }

  createAdminValvurDraft(_payload: CourseSettingsData): void {
    throw new Error(
      'SchoolCourseCreatorBridge: admin VALVUR draft is not available in this host.',
    );
  }

  publishCourse(courseId: string): Promise<ChallengeGen.Course> {
    return this.#course.publishCourse.mutateAsync(courseId);
  }

  generateVideo(dto: AiGen.GenerateVideoRequestDto): Promise<ChallengeGen.Task> {
    return this.#course.generateVideo.mutateAsync(dto);
  }

  generateAudio(dto: AiGen.GenerateAudioRequestDto): Promise<ChallengeGen.Task> {
    return this.#course.generateAudio.mutateAsync(dto);
  }
}
